export function getCorrCutValues() {
  const cutValues = [...Array(9).keys()]
    .map((index) => {
      const value = Number(`0.${index + 1}`);
      return {
        label: `-${value} e +${value}`,
        value,
      };
    });
  return cutValues;
}

export function getCorrCutValueIndex(value) {
  const cutValues = getCorrCutValues();
  const index = cutValues.findIndex((item) => item.value === value);
  return index;
}

export function getCorrCutValue(value) {
  const cutValues = getCorrCutValues();
  const index = getCorrCutValueIndex(value);
  return cutValues[index];
}
